<svg
  class="icon-caret"
  [style.transform]="rotate"
  [attr.width]="width"
  [attr.height]="height"
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path 
    d="M4.40002 9.85C4.25557 9.70555 4.18335 9.52778 4.18335 9.31667C4.18335 9.10556 4.25557 8.92778 4.40002 8.78333L7.46668 5.71667C7.54446 5.63889 7.62779 5.58333 7.71668 5.55C7.80557 5.51667 7.90002 5.5 8.00002 5.5C8.10002 5.5 8.19446 5.51667 8.28335 5.55C8.37224 5.58333 8.45557 5.63889 8.53335 5.71667L11.6167 8.8C11.7611 8.94444 11.8307 9.11667 11.8253 9.31667C11.8196 9.51667 11.7445 9.69444 11.6 9.85C11.4556 9.98333 11.2778 10.05 11.0667 10.05C10.8556 10.05 10.6778 9.98333 10.5333 9.85L8.00002 7.3L5.45002 9.86667C5.30557 10 5.13335 10.0667 4.93335 10.0667C4.73335 10.0667 4.55557 9.99444 4.40002 9.85Z" 
    [attr.fill]="color"
  />
</svg>